import { render } from "./AddPartner.vue?vue&type=template&id=3ba19a5d"
import script from "./AddPartner.vue?vue&type=script&lang=js"
export * from "./AddPartner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__